import { defineComponent, inject, createVNode } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import IconEmpty from "../icon/icon-empty/index.js";
import { useI18n } from "../locale/index.js";
import { configProviderInjectionKey } from "../config-provider/context.js";
var _Empty = defineComponent({
  name: "Empty",
  props: {
    description: String,
    imgSrc: String
  },
  setup(props, {
    slots
  }) {
    const prefixCls = getPrefixCls("empty");
    const {
      t
    } = useI18n();
    const configCtx = inject(configProviderInjectionKey, void 0);
    return () => {
      var _a, _b, _c, _d;
      if ((configCtx == null ? void 0 : configCtx.slots.empty) && !(slots.image || props.imgSrc)) {
        return configCtx.slots.empty();
      }
      return createVNode("div", {
        "class": prefixCls
      }, [createVNode("div", {
        "class": `${prefixCls}-image`
      }, [(_b = (_a = slots.image) == null ? void 0 : _a.call(slots)) != null ? _b : props.imgSrc ? createVNode("img", {
        "src": props.imgSrc,
        "alt": props.description || "empty"
      }, null) : createVNode(IconEmpty, null, null)]), createVNode("div", {
        "class": `${prefixCls}-description`
      }, [(_d = (_c = slots.default) == null ? void 0 : _c.call(slots)) != null ? _d : props.description || t("empty.description")])]);
    };
  }
});
export { _Empty as default };
